import React from 'react';
import { Card, Button, Image } from 'semantic-ui-react';

const MyLocationCard = ({ changeMapCenter, location }) => {
  return (
    <Card fluid className="Hospitals__SideBar__LocationCard">
      <Card.Content>
        <Card.Header>
          <Image src={require('../../../../assets/images/markers/yellowMarker.png')} />
          {' Mijn locatie'}
          <Button
            content="Vind op map"
            floated="right"
            size="mini"
            onClick={() => changeMapCenter(location)}
          />
        </Card.Header>
      </Card.Content>
    </Card>
  );
};

export default MyLocationCard;



// WEBPACK FOOTER //
// ./src/components/Hospitals/SubComponents/Cards/MyLocationCard.js